import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetComponentByFlow = createAsyncThunk(
  "GetComponentByFlow",
  async (flow, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/FlowComponentRound/GetComponentByFlowGUID",
        {
          appiliacationInfo: flow.appiliacationInfo,
          flowGUID: flow.flowGUID,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetComponentByFlow");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const OneComponentByFlow = createSlice({
  name: "OneComponentByFlow ",
  initialState: {
    OneComponentByFlow: [],
    loadingOneComponentByFlow: false,
    errorOneComponentByFlow: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetComponentByFlow.pending, (state, action) => {
        state.loadingOneComponentByFlow = true;
        state.OneComponentByFlow = action.payload;
        state.errorOneComponentByFlow = null;
      })
      .addCase(GetComponentByFlow.fulfilled, (state, action) => {
        state.loadingOneComponentByFlow = false;
        state.OneComponentByFlow = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetComponentByFlow.rejected, (state, action) => {
        state.loadingOneComponentByFlow = false;
        state.errorOneComponentByFlow = action.payload;
      });
  },
});

export default OneComponentByFlow.reducer;
